"use client";

import { useEffect, useRef, useState } from "react";

/**
 * Tombol "ke atas" global — CUSTOM, tanpa package (perilaku ~15 baris;
 * dependensi ekstra tak sepadan, preseden repo: lottie-react dibuang,
 * `<details>` native, pola sentinel IO navbar).
 *
 * Mekanika = pola LandingNavMorph: sentinel 1px di puncak halaman +
 * IntersectionObserver (rootMargin -480px) + boolean-flip guard → nol kerja
 * per-frame scroll. Muncul setelah ~480px scroll, cross-fade opacity/translate
 * (pointer-events mati saat tersembunyi — tak menghalangi klik).
 *
 * Posisi: kanan-bawah; mobile dinaikkan ke bottom-20 supaya tak menimpa
 * sticky purchase bar halaman detail ujian (fixed bottom-0, ~64px).
 * Reduced-motion: scrollTo 'auto', tanpa smooth.
 */
export function BackToTop() {
  const [show, setShow] = useState(false);
  const sentinelRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = sentinelRef.current;
    if (!el) return;
    const io = new IntersectionObserver(
      (entries) => {
        const past = !entries[0]?.isIntersecting;
        setShow((prev) => (prev === past ? prev : past)); // flip guard
      },
      // rootMargin POSITIF +480px = area IO diperluas 480px ke atas viewport →
      // sentinel (di puncak dokumen) tetap beririgan selama scrollY < 480;
      // lewat itu → tombol tampil. (Margin negatif salah arah: sentinel tak
      // pernah beririnan → tombol selalu tampil — tertangkap tes 2026-09-25.)
      { rootMargin: "480px 0px 0px 0px", threshold: 0 },
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  const toTop = () =>
    window.scrollTo({
      top: 0,
      behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches
        ? "auto"
        : "smooth",
    });

  return (
    <>
      <div ref={sentinelRef} aria-hidden="true" className="absolute top-0 h-px w-px" />
      <button
        type="button"
        onClick={toTop}
        aria-label="Kembali ke atas"
        className={`border-border bg-card/95 text-foreground/70 hover:border-primary/40 hover:text-primary fixed right-4 bottom-20 z-40 grid size-11 place-items-center rounded-full border backdrop-blur-md transition-[opacity,transform,border-color,color] duration-300 ease-out lg:right-6 lg:bottom-6 ${
          show
            ? "translate-y-0 opacity-100"
            : "pointer-events-none translate-y-3 opacity-0"
        }`}
      >
        <span className="text-base leading-none font-black" aria-hidden="true">
          ↑
        </span>
      </button>
    </>
  );
}
